import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const chatbotAPI = axios.create({
  baseURL: `${API_BASE}/api/chatbots`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Update chatbot config by chatbotId
export const updateChatbotConfig = async (chatbotId, data) => {
  const response = await chatbotAPI.post(`/updatechatbots/${chatbotId}`, data);
  return response.data;
};

export const updateChatbotStatus = async (chatbotId, data) => {
  const response = await chatbotAPI.post(`/updateChatbotStatus/${chatbotId}`, data);
  return response.data;
};




// Get all chatbots for an instance
export const getAllChatbots = async (instanceId) => {
  const response = await chatbotAPI.get(`/${instanceId}`);
  return response.data;
};

// Get chatbot config by chatbotId
export const getChatbotConfig = async (chatbotId) => {
  const response = await chatbotAPI.get(`/getchatbots/${chatbotId}`);
  return response.data;
};



export const deleteChatbot = async (chatbotId) =>{
    const response = await chatbotAPI.post(`/deleteChatbot/${chatbotId}`);
  return response.data;
}